import { Fragment } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import Grid from '@zenbusiness/zui/Grid';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import OfferCard from './OfferCard';

import { chaseAndBluevineOffers } from '../constants/messages';
import useBankingCards from '../hooks/useBankingCards';

const ChaseAndBluevineOffers = ({ clickstreamInfo }) => {
  const navigate = useNavigate();
  const { chaseCard, bluevineCard } = useBankingCards(clickstreamInfo);
  const bankingCards = [chaseCard, bluevineCard];

  const trackCancelPressed = useButtonPressedCallback({
    elementName: 'not_interested_in_chase_and_bluevine_offer',
    elementText: 'No thanks',
    appPageName: 'banking_upsell_dashboard'
  });

  const handleCancel = () => {
    /**
     * Tracking Details: Tracking to be added on click of “No Thanks”
     * Question: How many customers  click on “No Thanks”?
     */
    trackCancelPressed();
    navigate('/dashboard');
  };

  return (
    <>
      <Stack
        gap={{ xs: 4.5, md: '38px' }}
        mt={{ xs: 1, md: 4 }}
      >
        <Stack spacing={{ xs: 1, md: 2 }}>
          {chaseAndBluevineOffers.map((offer) => (
            <Fragment key={offer.title}>
              <Text
                color="primary"
                mt={{ xs: 2, md: 0 }}
                size="lg"
                weight="medium"
              >
                {offer.title}
              </Text>
              {offer.features.map((feature) => (
                <Stack
                  alignItems="flex-start"
                  direction="row"
                  key={feature}
                  spacing={1}
                >
                  <SharedAsset
                    alt="boltrounded icon"
                    color="#FFB548"
                    src="/s2/material-icons/boltrounded.svg"
                    width="24px"
                  />
                  <Text
                    size="md"
                    sx={{ color: 'primary.light' }}
                  >
                    {feature}
                  </Text>
                </Stack>
              ))}
            </Fragment>
          ))}
        </Stack>
        <Stack gap={{ xs: 1.5, md: 2 }}>
          <Grid
            container
            spacing={{ xs: 1.5, md: 1 }}
          >
            {bankingCards.map((card) => (
              <Grid
                item
                key={card.id}
                md={bankingCards.length ? 12 / bankingCards.length : 12}
                xs={12}
              >
                <OfferCard {...card} />
              </Grid>
            ))}
          </Grid>
          <Stack
            alignItems="center"
            justifyContent="center"
          >
            <Box
              component="button"
              onClick={handleCancel}
              sx={{
                all: 'unset',
                cursor: 'pointer'
              }}
              type="button"
            >
              <Text
                color="primary"
                component="span"
                size="md"
                sx={{ textDecoration: 'underline' }}
                weight="medium"
              >
                No thanks
              </Text>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
ChaseAndBluevineOffers.propTypes = {
  clickstreamInfo: PropTypes.shape({
    modalName: PropTypes.string
  })
};

export default ChaseAndBluevineOffers;
